import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';

export const Row = styled.tr`
  height: 30px;
  align-items: center;
  margin: 1px 0;
`;

export const FirstRow = styled.td`
  flex-direction: row;
  display: flex;
  gap: 8px;
  height: 30px;
  padding: 3px 0 0 0;

  > span {
    color: #222222;
    font-size: 16px;
    font-family: Poppins;
    font-weight: 500;
    height: 24px;
  }
`

export const SecondRow = styled.td`
  > span {
    color: #222222;
    font-size: 16px;
    font-family: Poppins;
    font-weight: 500;
    height: 24px;
  }
`

export const ActionsDiv = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;

  svg,
  img {
    width: 15px;
    height: 20px;
    cursor: pointer;
    color: #ff2c3a;
  }
`;

export const DeletePaymentForm = styled(Link)`
  padding-bottom: 5px;
  color: red;
`;

export const MaquininhaPaymentAlertContainer = styled.div`
  color: #94090F;
  background-color: #FAE8E9;
  border-radius: 50px;
  width: fit-content;
  padding: 4px 12px;
  font-weight: 600;
  font-family: Poppins;
  font-size: 11px;
  height: fit-content;
`